module.exports = __webpack_public_path__ + "images/interview-Chevron-2.svg";